module.exports = __webpack_public_path__ + "static/img/av3.664b2edb.png";